
var v_bsAgentServer = null

//AGP 地址IP
var v_wsIP = null
//AGP 地址端口
var v_wsPort = null
export default {
  initData: function (opt) {
    v_bsAgentServer = opt?.agentServer
    v_wsIP = opt?.agpIp
    v_wsPort = opt?.agpPort
  },

  /*
  JS生成GUID工具
  使用方法
  var guid = new GUID();
  alert(guid.newGUID());　
  */
  $GUID: {
    // let date= new Date(),
    newGUID: function () {
      let date = new Date()
      var guidStr = ''
      let sexadecimalDate = this.hexadecimal(this.getGUIDDate(date), 16)
      let sexadecimalTime = this.hexadecimal(this.getGUIDTime(date), 16)
      for (var i = 0; i < 9; i++) {
        guidStr += Math.floor(Math.random() * 16).toString(16)
      }
      guidStr += sexadecimalDate
      guidStr += sexadecimalTime
      while (guidStr.length < 32) {
        guidStr += Math.floor(Math.random() * 16).toString(16)
      }
      return this.formatGUID(guidStr)
    },
    /*
* 功能：获取当前日期的GUID格式，即8位数的日期：19700101
* 返回值：返回GUID日期格式的字条串
*/
    getGUIDDate: function (date) {
      return date.getFullYear() + this.addZero(date.getMonth() + 1) + this.addZero(date.getDay())
    },
    /*
 * 功能：获取当前时间的GUID格式，即8位数的时间，包括毫秒，毫秒为2位数：12300933
 * 返回值：返回GUID日期格式的字条串
 */
    getGUIDTime: function (date) {
      return this.addZero(date.getHours()) + this.addZero(date.getMinutes()) + this.addZero(date.getSeconds()) + this.addZero(parseInt(date.getMilliseconds() / 10))
    },

    /*
* 功能: 为一位数的正整数前面添加0，如果是可以转成非NaN数字的字符串也可以实现
* 参数: 参数表示准备再前面添加0的数字或可以转换成数字的字符串
* 返回值: 如果符合条件，返回添加0后的字条串类型，否则返回自身的字符串
*/
    addZero: function (num) {
      if (Number(num).toString() != 'NaN' && num >= 0 && num < 10) {
        return '0' + Math.floor(num)
      } else {
        return num.toString()
      }
    },

    /*
* 功能：将y进制的数值，转换为x进制的数值
* 参数：第1个参数表示欲转换的数值；第2个参数表示欲转换的进制；第3个参数可选，表示当前的进制数，如不写则为10
* 返回值：返回转换后的字符串
*/
    hexadecimal: function (num, x, y) {
      if (y != undefined) {
        return Number.parseInt(num.toString(), y).toString(x)
      } else {
        return Number.parseInt(num.toString()).toString(x)
      }
    },
    formatGUID: function (guidStr) {
      var str1 = guidStr.slice(0, 8) + '-',
        str2 = guidStr.slice(8, 12) + '-',
        str3 = guidStr.slice(12, 16) + '-',
        str4 = guidStr.slice(16, 20) + '-',
        str5 = guidStr.slice(20)
      return str1 + str2 + str3 + str4 + str5
    },
  },

  /**
  * 产生本次保持的操作类型定义
  */
  CONST_AgentHoldCallBeforOperation: function () {
    /**
    * 未知
    */
    this.Unknown = function () { return 0 }
    /**
    * 邀请座席加入三方或多方会议
    */
    this.InviteAgent = function () { return 1 }
    /**
    * 邀请外线加入三方或多方会议
    */
    this.InviteCallOut = function () { return 2 }
    /**
    * 转移外线并保持
    */
    this.TransferOutThenHold = function () { return 3 }
    /**
    * 转移外线并释放
    */
    this.TransferOutThenRelease = function () { return 4 }
  },
  /**
  * 根据错误编码获取错误信息
  * @param errCode 错误代码
  */
  err_Code (errCode) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: v_bsAgentServer + "/queryTIciptErrCodeByCode4Domain",
        crossDomain: true,
        type: 'POST',
        async: true,
        dataType: 'json',
        data: {
          "errCode": errCode
        },
        success: function (data) {
          console.log('err_Code data: ', data)
          resolve(data)
        },
        error: function (xhr, status, error) {
          console.error('err_Code Error: ', error) // 查看具体的错误信息
          reject(error)
        },
      })
    })
  },
  /**
       *
       * 后台记录相关日志
       */
  saveData: function (data) {
    $.ajax({
      url: this.v_bsAgentServer + "/saveData",
      type: 'POST',
      async: true,
      dataType: 'json',
      data: {
        "data": data
      },
    })
  },

  /**
  * 下载指定URL下的文件
  * @param strURL 要被下载的文件
  * ||(browObj.mozilla)
  */
  downloadFileFromURL (strURL) {
    //window.open("downRecord?path="+strURL,"_blank");

    let browObj = $.browser
    let strLocalFileName = null
    if ((strURL == null) || (strURL.trim() == ""))
      return false
    strLocalFileName = strURL.substr(strURL.lastIndexOf("/") + 1)
    if ((browObj) && ((browObj.safari) || (browObj.opera))) {
      let aObj = document.createElement('a')
      aObj.href = "downRecord?path=" + strURL, "_blank"
      aObj.download = strLocalFileName
      aObj.click()
      return true
    }
    $.ajax(
      {
        type: "post",
        url: v_bsAgentServer + "/downloadRecord",
        data: "path=" + strPath,
        async: false,
        success: function (data) {
          location.href = data
        }
      })
    return true
  },


  /**
   * 获取本地号码前缀
   */
  getTelNoPrefix: function () {
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'post',
        url: v_bsAgentServer + "/syncMobileCode4Domain",
        data: {},
        success: function (data) {
          console.log('getTelNoPrefix', data)
          resolve(data)
        },
        error: function (xhr, status, error) {
          console.error('getTelNoPrefix Error:', error) // 查看具体的错误信息
          reject(error)
        },
      })
    })
  },
  /**
   * 获取座席状态统计信息
   * @returns 
   */
  getAgentStatusCount: function () {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: v_bsAgentServer + "/getStatusCount4Domain",
        crossDomain: true,
        type: 'POST',
        async: true,
        dataType: 'json',
        success: function (data) {
          resolve(data)
        },
        error: function (xhr, status, error) {
          console.error('getTelNoPrefix Error:', error) // 查看具体的错误信息
          reject(error)
        },
      })
    })
  },

  /**
   * 获取当前座席配置
   * @returns 
   */
  loadAgendSetting: function (agentId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: v_bsAgentServer + "/loadTIcipAgPersonalized4Domain",
        crossDomain: true,
        type: 'POST',
        async: true,
        dataType: 'json',
        data: {
          "agentId": agentId
        },
        success: function (data) {
          console.log('initAgentSet data', data)
          resolve(data)
        },
        error: function (xhr, status, error) {
          console.error('loadAgendSetting Error:', error) // 查看具体的错误信息
          reject(error)
        },
      })
    })
  },
  /**
   * 更新座席配置
   * @param {*} data 
   * @returns 
   */
  updateAgendSetting: function (data) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: v_bsAgentServer + "/update4Domain",
        crossDomain: true,
        type: 'POST',
        async: true,
        dataType: 'json',
        data: {
          "objectJson": JSON.stringify(data)
        },
        success: function (data) {
          resolve(data)

        },
        error: function (xhr, status, error) {
          console.error('updateAgendSetting Error:', error) // 查看具体的错误信息
          reject(error)
        },
      })
    })
  },

  /**
   * 保存VDN等登录信息到后台的Session
   */
  saveAgentLoginInfo: function (vdnId, agentId, workNo, password, sessionId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: v_bsAgentServer + "/saveAgentLoginInfo2Session4Domain",
        crossDomain: true,
        type: 'POST',
        async: true,
        dataType: 'json',
        data: {
          "vdnId": vdnId,
          "agentId": agentId,
          "workNo": workNo,
          "password": password,
          "sessionId": sessionId
        },
        success: function (data) {
          resolve(data)
        },
        error: function (xhr, status, error) {
          console.error('updateAgendSetting Error:', error) // 查看具体的错误信息
          reject(error)
        },
      })
    })
  },

  /**
    * 获取当前座席来去电弹屏参数设置
    */
  loadCallPopupSettingList () {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: v_bsAgentServer + "/loadCallPopupSettingList4Domain",
        crossDomain: true,
        type: 'POST',
        async: true,
        dataType: 'json',
        data: {},
        success: function (data) {
          resolve(data)
          // g_CallPopupSettingList = []
          // if (data != null) {
          //   data.forEach(item => {
          //     let callPopupSettingObj = new CallPopupSetting
          //       (
          //         item.popuptype,
          //         item.openurl,
          //         item.paramname4vdnid,
          //         item.paramname4workno,
          //         item.paramname4agtelno,
          //         item.paramname4caller,
          //         item.paramname4called,
          //         item.paramname4basecallpid,
          //         item.paramname4agcallpid,
          //         item.paramname4busipid
          //       )
          //     g_CallPopupSettingList.push(callPopupSettingObj)
          //   })
          // }
        },
        error: function (xhr, status, error) {
          console.error('loadCallPopupSettingList Error:', error) // 查看具体的错误信息
          reject(error)
        },
      })
    })
  },

  /**
   * 获取vnd列表
   * @returns 
   */
  initVDN: function () {
    let that = this
    return new Promise((resolve, reject) => {
      $.ajax({
        url: v_bsAgentServer + "/initVdn4Domain",
        crossDomain: true,
        type: 'POST',
        async: true,
        dataType: 'json',
        data: {},
        success: function (data) {
          console.log('initVDN data', data)
          resolve(data)
        },
        error: function (xhr, status, error) {
          console.error('initVdn Error:', error) // 查看具体的错误信息
          reject(error)
        },
      })
    })
  },

  //获取外呼时送出的主叫号码等座席参数
  getAgent (vdnId, agendId, workno) {
    let that = this
    return new Promise((resolve, reject) => {
      $.ajax({
        url: v_bsAgentServer + "/getAgent4Domain",
        crossDomain: true,
        type: 'POST',
        async: true,
        dataType: 'json',
        data: {
          "vdnId": vdnId,
          "agentId": agendId,
          "workNo": workno
        },
        success: function (data) {
          console.log('getAgent data', data)
          resolve(data)
        },
        error: function (xhr, status, error) {
          console.error('getAgent Error:', error) // 查看具体的错误信息
          reject(error)
        }
      })
    })


  },

  /**
   * 获取号码区域信息
   * @param {*} callNum 
   * @returns 
   */
  areaInfo: function (callNum) {
    return new Promise((resolve, reject) => {
      if (callNum.length <= 8) {
        resolve('广东 广州')
      } else {
        //alert(caller);
        $.ajax({
          url: v_bsAgentServer + "/getTCommonArea4Domain",
          crossDomain: true,
          type: 'POST',
          async: true,
          dataType: 'json',
          data: {
            "code": callNum
          },
          success: function (data) {
            let area = "未知"
            if ((data != null) && (data.province) && (data.city)) {
              area = data.province + " " + data.city
            }
            resolve(area)
            // $('#txt_area').val(area)
          },
          error: function (xhr, status, error) {
            console.error('areaInfo Error:', error) // 查看具体的错误信息
            reject(error)
          }
        })
      }
    })
  },
  /**
   * 根据工号获取座席信息
   * @param {*} workno 
   * @returns 
   */
  getUserByWorkNo: function (workno) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: v_bsAgentServer + "/getUserByWorkNo",
        crossDomain: true,
        type: 'POST',
        async: true,
        dataType: 'json',
        data: {
          "workNo": workno // 这里返回的被叫号码其实是被呼座席的工号
        },
        success: function (data) {
          resolve(data)
        },
        error: function (xhr, status, error) {
          console.error('initGroups Error:', error) // 查看具体的错误信息
          reject(error)
        }
      })
    })
  },
  /**
   * 获取座席技能组信息
   * @param {*} agentId 
   * @param {*} groupName 
   * @param {*} showAllGroup 
   * @returns 
   */
  initGroups: function (agentId, groupName, showAllGroup) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: v_bsAgentServer + "/loadTheGroup4Domain",
        crossDomain: true,
        type: 'POST',
        async: true,
        dataType: 'json',
        data: {
          "agentId": agentId,
          "groupName": groupName,
          "showAllGroup": showAllGroup
        },
        success: function (result) {
          resolve(result)
        },
        error: function (xhr, status, error) {
          console.error('initGroups Error:', error) // 查看具体的错误信息
          reject(error)
        }
      })
    })
  },

  /**
   * 加载座席组及技能信息
   * @param { "agentId": '', 'groupName': '',  'skillName': ''} params 
   * @returns 
   */
  initGroupAndSkill: function (params) {
    console.log('initGroupAndSkill', params)
    return new Promise((resolve, reject) => {
      $.ajax({
        crossDomain: true,
        type: 'POST',
        async: true,
        dataType: 'json',
        url: v_bsAgentServer + '/initGroupAndSkill4Domain',
        data: params,
        success: function (data) {
          resolve(data)
        },
        error: function (xhr, status, error) {
          console.error('initGroups Error:', error) // 查看具体的错误信息
          reject(error)
        }
      })
    })
  },

  /**
   * 根据技能id 获取技能组组信息
   * @param {*} skillIDs 
   * @returns 
   */
  getGroupIDsBySkillIds: function (skillIDs) {
    return new Promise((resolve, reject) => {
      if (skillIDs && skillIDs.length > 0) {
        $.ajax({
          url: v_bsAgentServer + "/getGroupIDsBySkillID4ACD4Domain",
          crossDomain: true,
          type: 'POST',
          async: true,
          dataType: 'json',
          data: {
            "skillIDs": skillIDs.join(',')
          },
          success: function (data) {
            console.log('getGroupIDsBySkillIds data', data)
            resolve(data)
          },
          error: function (xhr, status, error) {
            console.error('initGroups Error:', error) // 查看具体的错误信息
            reject(error)
          }
        })
      } else {
        resolve(null)
      }
    })
  },

  getSkillNameAndGroupName: function (groupId, skillId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: v_bsAgentServer + "/getSkillNameAndGroupName4Domain",
        crossDomain: true,
        type: 'POST',
        async: true,
        dataType: 'json',
        data: {
          "groupId": groupId,
          "skillId": skillId,
        },
        success: function (data) {
          console.log('getSkillNameAndGroupName data', data)
          resolve(data)
        },
        error: function (xhr, status, error) {
          console.error('getSkillNameAndGroupName Error:', error) // 查看具体的错误信息
          reject(error)
        }
      })
    })
  },
  /**
   * 根据座席组id获取技能
   * @param {*} agentGroupId 
   * @returns 
   */
  loadAgentAndSkillByGroupId: function (agentGroupId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: v_bsAgentServer + "/loadAgentAndSkillByGroupId4Domain",
        crossDomain: true,
        type: 'POST',
        async: true,
        dataType: 'json',
        data: {
          "groupId": agentGroupId
        },
        success: function (data) {
          resolve(data)
        },
        error: function (xhr, status, error) {
          console.error('initGroups Error:', error) // 查看具体的错误信息
          reject(error)
        }
      })
    })
  },

  /**
   * 转接ivr
   * @returns 
   */
  initIVRGrid4Domain: function (data) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: v_bsAgentServer + "/initIVRGrid4Domain",
        crossDomain: true,
        type: 'POST',
        async: true,
        data: data,
        success: function (data) {
          resolve(data)
        },
        error: function (xhr, status, error) {
          console.error('initIVRGrid4Domain Error:', error) // 查看具体的错误信息
          reject(error)
        }
      })
    })
  },

  $Log: {
    /**
     * js记录日志
     * @param {*} level  
     *  Debug Info Warn Error Fatal
     * @param {*} msg 
     */
    send: function (level, msg) {
      try {
        $.ajax({
          url: v_bsAgentServer + "/writeLog",
          crossDomain: true,
          type: 'POST',
          async: true,
          dataType: 'json',
          data: {
            "level": level,
            "msg": encodeURIComponent("话务工具条日志：" + msg)
          },
          success: function (data) {
            // console.log('fatal', data)
          },
          error: function (xhr, status, error) {
            console.error('send Error:', error) // 查看具体的错误信息
          }
        })
      } catch (error) {
        console.log('Log ' + level + ' error', error)
      }
    },
    /**
     * 输出异常的详情
     * @param {*} e 
     * @returns 
     */
    message: function (e) {
      var strMsg = ""
      if ((e != undefined) && (e != null)) {
        if ((e.name != undefined) && (e.name != null))
          strMsg = strMsg + ",异常名称:" + e.name
        if ((e.message != undefined) && (e.message != null))
          strMsg = strMsg + ",异常详情:" + e.message
        if ((e.fileName != undefined) && (e.fileName != null))
          strMsg = strMsg + ",异常文件:" + e.fileName
        if ((e.lineNumber != undefined) && (e.lineNumber != null))
          strMsg = strMsg + ",异常行号:" + e.lineNumber
        if ((e.stack != undefined) && (e.stack != null))
          strMsg = strMsg + ",异常栈:" + e.stack
      }
      //if(strMsg.length > 0)
      //	strMsg = strMsg.substr(1);
      return strMsg
    }
  }

}